import { render, staticRenderFns } from "./TransactionPage.vue?vue&type=template&id=07a283d7&scoped=true&"
import script from "./TransactionPage.vue?vue&type=script&lang=js&"
export * from "./TransactionPage.vue?vue&type=script&lang=js&"
import style0 from "./TransactionPage.vue?vue&type=style&index=0&id=07a283d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a283d7",
  null
  
)

export default component.exports